import React from 'react'

import { Text } from '@wartek-id/text-v1'

import { CardSummary } from 'app/KinerjaPSPegawaiPage/components/CardSummary'

type TSectionDokumenAkuntabilitasProps = {}

export const SectionPelaksanaanTugas: React.FC<
  TSectionDokumenAkuntabilitasProps
> = () => {
  return (
    <>
      <CardSummary title="Pelaksanaan Tugas">
        <div className="bg-white rounded-b-md p-6">
          <div className="py-2.5 space-y-4">
            <Text>
              Dokumen Perencanaan Pendampingan Satuan Pendidikan Sesuai Binaan
            </Text>
            <Text>
              Dokumen Pelaporan Pendampingan Satuan Pendidikan Sesuai Binaan
            </Text>
          </div>
        </div>
      </CardSummary>
    </>
  )
}
